import React from 'react';
import { Box, Typography } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

const VideoContent = ({ 
    item, 
    index, 
    isMobile, 
    videoStates, 
    handleVideoClick, 
    handleVideoPlay, 
    handleVideoPause 
}) => {
    //console.log("VideoContent item:", item, "index:", index, "isMobile:", isMobile, "videoStates:", videoStates);
    const videoId = `video-${index}`;
    const videoState = videoStates[videoId] || { showControls: false, isPlaying: false };
    
    return (
        <Box 
            key={index} 
            sx={{ 
                height: isMobile ? '350px' : '441px',
                width: isMobile ? '95%' : '701px',
                maxWidth: isMobile ? '350px' : '701px',
                marginBottom: '24px !important',
                position: 'relative',
                borderRadius: item.borderRadius || '8px',
                overflow: 'hidden',
                margin: '0 auto',
            }}
        >
            <video
                ref={(el) => {
                    if (el && videoState.isPlaying && !el.playing) {
                        el.play();
                    }
                }}
                style={{
                    height: isMobile ? '350px' : '441px',
                    width: '100%',
                    maxWidth: isMobile ? '350px' : '701px',
                    display: 'block',
                    objectFit: 'contain',
                    backgroundColor: item.backgroundColor || '#000'
                }}
                src={item.src}
                controls={videoState.showControls}
                onPlay={() => handleVideoPlay(videoId)}
                onPause={() => handleVideoPause(videoId)}
                playsInline
                preload="metadata"
            />
            
            {/* Play Button Overlay */}
            {!videoState.showControls && (
                <Box
                    onClick={() => handleVideoClick(videoId)}
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                        cursor: 'pointer',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.4)'
                        }
                    }}
                >
                    <Box
                        sx={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 1)',
                                transform: 'scale(1.1)'
                            }
                        }}
                    >
                        <PlayArrowIcon 
                            sx={{ 
                                fontSize: '40px', 
                                color: '#373737',
                                marginLeft: '4px'
                            }} 
                        />
                    </Box>
                </Box>
            )}
            
            {/* Optional: Video description/caption */}
            {item.caption && (
                <Typography
                    sx={{
                        fontSize: '14px',
                        color: item.captionColor || '#666',
                        textAlign: 'center',
                        marginTop: '8px',
                        fontStyle: 'italic'
                    }}
                >
                    {item.caption}
                </Typography>
            )}
        </Box>
    );
};

export default VideoContent;